module.exports = __webpack_public_path__ + "static/media/desktop.371c9ef7.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/ProductImagery/assets/desktop.png
// module id = 503
// module chunks = 0